import _ from 'lodash';
import React from 'react';
import ReactTooltip from 'react-tooltip';
// TODO: Import @material-ui from design-system folder
// eslint-disable-next-line restrict-imports/restrict-imports
import { makeStyles } from '@material-ui/core/styles';

import { FlagAuditResult } from '@scale/shared/defaults';
import { SpeedAuditResult } from './types';

interface FlagAuditFormProps {
  result: SpeedAuditResult;
  onChangeFlagResult: (flagResult: FlagAuditResult, flagValue: string) => void;
}

function FlagAuditForm({ onChangeFlagResult, result: { flagResult } }: FlagAuditFormProps) {
  const styles = useSpeedAuditFormStyles();

  const onChangeResult = function (
    auditResult: FlagAuditResult,
  ): React.ChangeEventHandler<HTMLInputElement> {
    return async function (event) {
      if (event.target.checked) {
        onChangeFlagResult(auditResult, event.target.value);
      }
    };
  };

  return (
    <div className={styles.form}>
      <div className={styles.legend}>Flag is:</div>
      {_.values(FlagAuditResult).map(auditResult => {
        return (
          <label key={auditResult} className={styles.scoreLabel} data-tip={auditResult}>
            <input
              className={styles.scoreRadio}
              type="radio"
              checked={flagResult === auditResult}
              value={auditResult}
              onChange={onChangeResult(auditResult)}
            />
            <kbd className={styles.kbd} style={{ backgroundColor: 'ffff00' }}>
              {auditResult}
            </kbd>
          </label>
        );
      })}
      <ReactTooltip />
    </div>
  );
}

const useSpeedAuditFormStyles = makeStyles({
  instrItemSelector: {
    padding: '8px',
    width: '300px',
    overflow: 'visible',
  },
  annotSelector: {
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
  },
  form: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'visible',
    paddingTop: '8px',
    paddingLeft: '24px',
    paddingRight: '24px',
    paddingBottom: '32px',
  },
  legend: {
    marginRight: '8px',
  },
  scoreLabel: {
    display: 'inline-block',
    paddingLeft: '8px',
    paddingRight: '8px',
  },
  scoreRadio: {
    position: 'absolute',
    clip: 'rect(0, 0, 0, 0)',
    '&:not(:checked) + kbd': {
      opacity: 0.2,
    },
  },
  kbd: {
    padding: '4px 8px',
    color: 'black',
    fontSize: '16px',
    borderRadius: '2px',
    display: 'inline-block',
  },
  note: {
    marginLeft: '24px',
    width: '600px',
    height: 'max-content',
  },
});

export default React.memo(FlagAuditForm);
